// extracted by mini-css-extract-plugin
export default {"employees":"statisticsEmployees_employees__86ATu","header":"statisticsEmployees_header__EYQJP","table":"statisticsEmployees_table__5mQS5"};